<div>
  <div
    *ngIf="showPage"
    (click)="back()"
    class="d-flex gap-1 align-items-center back mb-2"
    style="cursor: pointer"
  >
    <i *ngIf="translate.currentLang == 'ar'" class="fa fa-chevron-right"></i>
    <i *ngIf="translate.currentLang == 'en'" class="fa fa-chevron-left"></i>
    <span>{{ "back-to-tickets" | translate }}</span>
  </div>
  <div
    *ngIf="!showPage"
    (click)="BackPaymentMobile()"
    class="d-flex gap-1 align-items-center back mb-2"
    style="cursor: pointer"
  >
    <i *ngIf="translate.currentLang == 'ar'" class="fa fa-chevron-right"></i>
    <i *ngIf="translate.currentLang == 'en'" class="fa fa-chevron-left"></i>
    <span>{{ "back-to-payment" | translate }}</span>
  </div>
  <app-book-title
    *ngIf="showPage"
    booktitle="ticket-reservation"
    info=""
  ></app-book-title>
  <div class="row mt-4">
    <div *ngIf="showPage" class="col-lg-4 col-md-12 col-12">
      <div class="coupon-card padding-5">
        <p class="code-label">{{ "Discount Code" | translate }}</p>
        <div class="d-flex gap-1">
          <input
            type="text"
            [ngStyle]="{
              'background-color':
                couponDiscount?.promoCodeApplied == true ? '#F7F7FD' : ''
            }"
            style="border-radius: 4px; border: 1px solid #e8e7e0"
            class="form-control"
            placeholder="MAS123"
            aria-label="name"
            [(ngModel)]="copoun"
          />
          <button
            *ngIf="
              couponDiscount?.promoCodeApplied == false ||
              couponDiscount?.promoCodeApplied == null
            "
            (click)="validateCoupon()"
            class="btn apply-btn"
          >
            {{ "Check" | translate }}
          </button>
          <button
            *ngIf="couponDiscount?.promoCodeApplied == true"
            (click)="cancelCoupon()"
            class="btn cancel-btn"
          >
            {{ "Cancel" | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="isMobile" class="col-12 px-0">
        <app-review-details
          [event]="event"
          [invoice]="invoice"
          (detailsMobileOpened)="showReview($event)"
          [showPage]="showPage"
        ></app-review-details>
      </div>
      <!-- ================================================= -->
      <div
        class="coupon-card padding-5 mt-5"
        style="display: flex; gap: 3px"
        *ngIf="whatsAppObject?.active && +(whatsAppObject?.price ?? 0)"
      >
        <label class="switch m-0">
          <input
            type="checkbox"
            [(ngModel)]="automaticActive"
            (ngModelChange)="onWhatsAppToggle()"
          />
          <span class="slider round"></span>
        </label>
        <p class="order-summary-value d-inline" style="margin-inline: 3px">
          {{ "Receive your tickets via WhatsApp for" | translate }}
          <span
            class="order-summary-value"
            [innerHTML]="
              whatsAppObject.price
                | number : '1.2-2'
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
            "
          ></span>
        </p>
      </div>
      <!-- ================================================= -->
      <div class="coupon-card margin-container">
        <p class="order-summary-label padding-5 pb-0">
          {{ "order-summary" | translate }}
        </p>
        <div class="padding-5 pt-0 pb-0">
          <!-- ticket-prices -->
          <div class="row">
            <div class="col-7">
              <p class="order-summary-title">
                {{ "ticket-prices" | translate }}
              </p>
            </div>
            <div class="col">
              <p class="order-summary-value" style="float: inline-end">
                <ng-container *ngIf="subTotal !== 0">
                  <span
                    [innerHTML]="
                      subTotal
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
                    "
                  ></span>
                </ng-container>
                <ng-container *ngIf="subTotal === 0">
                  {{ "free" | translate }}
                </ng-container>
              </p>
            </div>
          </div>
          <!-- VAT  -->
          <div class="row">
            <div class="col-7">
              <p class="order-summary-title">{{ "VAT" | translate }}</p>
            </div>
            <div class="col">
              <p class="order-summary-value" style="float: inline-end">
                <ng-container *ngIf="vat !== 0">
                  <span
                    [innerHTML]="
                      vat | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
                    "
                  ></span>
                </ng-container>
                <ng-container *ngIf="vat === 0"> ____ </ng-container>
              </p>
            </div>
          </div>
          <!-- Whatsapp fees -->
          <div class="row" *ngIf="automaticActive">
            <div class="col-7">
              <p class="order-summary-title">
                {{ "Send tickets via WhatsApp" | translate }}
              </p>
            </div>
            <div class="col">
              <p class="order-summary-value text-end" style="float: inline-end">
                <ng-container>
                  <span
                    [innerHTML]="
                      whatsappfees
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
                    "
                  ></span>
                </ng-container>
              </p>
            </div>
          </div>
          <!-- Service Charges -->
          <div class="row" *ngIf="+(serviceChargesObject?.price ?? 0)">
            <div class="col-7">
              <p class="order-summary-title">
                {{ "Service Charges" | translate }}
              </p>
            </div>
            <div class="col">
              <p class="order-summary-value text-end" style="float: inline-end">
                <ng-container>
                  <span
                    [innerHTML]="
                      servicesharges
                        | number : '1.2-2'
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 26
                    "
                  ></span>
                </ng-container>
              </p>
            </div>
          </div>
          <!--Discount   -->
          <div class="row">
            <div class="col-7">
              <p class="order-summary-title">{{ "Discount" | translate }}</p>
            </div>
            <div class="col">
              <p class="order-summary-value" style="float: inline-end">
                <ng-container *ngIf="couponDiscount">
                  <span
                    [innerHTML]="
                      couponDiscount?.discountAmount
                        | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
                    "
                  ></span>
                </ng-container>
                <ng-container *ngIf="!couponDiscount"> ____ </ng-container>
              </p>
            </div>
          </div>
        </div>

        <hr class="dashed" />
        <div class="row padding-5 pt-0">
          <div class="col-7">
            <p class="order-summary-title">{{ "total-price" | translate }}</p>
          </div>
          <div class="col">
            <p
              class="order-summary-value font-weight-bold"
              style="color: #f9a127; float: inline-end"
            >
              <ng-container *ngIf="total !== 0">
                <span
                  [innerHTML]="
                    total | customCurrency : 'SAR' : 'symbol' : '#f9a127' : 30
                  "
                ></span>
              </ng-container>
              <ng-container *ngIf="total === 0">
                {{ "free" | translate }}
              </ng-container>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showPage" class="col-lg-1"></div>
    <div *ngIf="!isMobile" class="col-lg-7 col-md-12 col-12">
      <app-review-details
        [event]="event"
        [invoice]="invoice"
        (detailsMobileOpened)="showReview($event)"
        [showPage]="showPage"
      ></app-review-details>
    </div>
    <div *ngIf="isMobile && !showPage" class="col-lg-7 col-md-12 col-12">
      <app-review-details-mobile
        [event]="event"
        [invoice]="invoice"
      ></app-review-details-mobile>
    </div>
  </div>
</div>
